if (!customElements.get('product-reviews')) {
  customElements.define(
    'product-reviews',
    class ProductReviews extends HTMLElement {
      static ratingLabels = ['', 'Muy mal', 'Mal', 'Normal', 'Bien', '¡Excelente!'];

      async connectedCallback() {
        this.perPage = Number(this.dataset.perPage) || 9;
        this.storageKey = this.dataset.storageKey;
        this.state = { filter: null, sort: 'featured', shown: this.perPage };
        this.starSvg = this.querySelector('[data-star]').innerHTML;
        this.commentsUrl = this.dataset.commentsUrl;

        this.list = this.querySelector('[data-list]');
        this.form = this.querySelector('[data-form]');
        this.moreWrap = this.querySelector('[data-more-wrap]');
        this.lightbox = this.querySelector('[data-lightbox]');

        this.bindEvents();

        try {
          const response = await fetch(this.dataset.src);
          this.demo = await response.json();
        } catch (error) {
          this.demo = [];
        }
        this.shared = this.loadShared();
        this.local = this.loadLocal();
        this.render();
      }

      bindEvents() {
        this.querySelector('[data-open-form]').addEventListener('click', () => this.toggleForm(true));
        this.querySelector('[data-close-form]').addEventListener('click', () => this.toggleForm(false));
        this.querySelector('[data-more]').addEventListener('click', () => {
          this.state.shown += this.perPage;
          this.renderList();
        });
        this.querySelector('[data-sort]').addEventListener('change', (event) => {
          this.state.sort = event.target.value;
          this.state.shown = this.perPage;
          this.renderList();
        });
        this.form.addEventListener('change', (event) => {
          if (event.target.name === 'rating') {
            this.querySelector('[data-rating-text]').textContent = ProductReviews.ratingLabels[event.target.value];
          }
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.submit();
        });
        this.list.addEventListener('click', (event) => {
          const img = event.target.closest('.rv__photos img');
          if (!img || !this.lightbox.showModal) return;
          this.lightbox.querySelector('img').src = img.src;
          this.lightbox.showModal();
        });
        this.lightbox.addEventListener('click', () => this.lightbox.close());
      }

      // Reseñas compartidas: comentarios de la entrada de blog con el formato "[5★] Título ¦ Texto"
      loadShared() {
        const source = this.querySelector('[data-shared-reviews]');
        if (!source) return [];
        try {
          return JSON.parse(source.textContent)
            .map((comment) => {
              const match = String(comment.c).match(/^\[(\d)★\]\s*([\s\S]*?)\s*¦\s*([\s\S]*)$/);
              if (!match) return null;
              return { n: comment.n, d: comment.d, r: Number(match[1]), t: match[2], b: match[3] };
            })
            .filter((review) => review && review.r >= 1 && review.r <= 5);
        } catch (error) {
          return [];
        }
      }

      async postComment(review, email) {
        const clean = (text) => text.replace(/¦/g, '|');
        const response = await fetch(this.commentsUrl, {
          method: 'POST',
          headers: { Accept: 'text/html' },
          body: new URLSearchParams({
            form_type: 'new_comment',
            utf8: '✓',
            'comment[author]': review.n,
            'comment[email]': email,
            'comment[body]': `[${review.r}★] ${clean(review.t)} ¦ ${clean(review.b)}`,
          }),
        });
        if (!response.ok || /challenge/.test(response.url)) throw new Error('comment');
      }

      // Copia en el navegador de quien escribe, para verla al momento aunque la página aún no se haya recargado
      loadLocal() {
        try {
          return JSON.parse(localStorage.getItem(this.storageKey)) || [];
        } catch (error) {
          return [];
        }
      }

      saveLocal() {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(this.local));
          return true;
        } catch (error) {
          return false;
        }
      }

      get all() {
        const sharedKeys = new Set(this.shared.map((review) => `${review.n}|${review.b}`));
        const local = this.local.filter((review) => !sharedKeys.has(`${review.n}|${review.b}`));
        return [...local, ...this.shared, ...this.demo];
      }

      stars(rating) {
        return Array.from({ length: 5 }, (_, i) =>
          this.starSvg.replace('<svg', `<svg class="${i < Math.round(rating) ? 'is-on' : ''}"`)
        ).join('');
      }

      render() {
        this.renderSummary();
        this.renderList();
      }

      renderSummary() {
        const all = this.all;
        const total = all.length;
        const avg = total ? all.reduce((sum, review) => sum + review.r, 0) / total : 0;

        this.querySelector('[data-avg]').textContent = avg.toFixed(1).replace('.', ',');
        this.querySelector('[data-avg-stars]').innerHTML = this.stars(avg);
        this.querySelector('[data-avg-stars]').classList.add('rv__stars');
        this.querySelector('[data-count]').textContent = `${total.toLocaleString('es-ES')} reseñas`;

        const bars = this.querySelector('[data-bars]');
        bars.innerHTML = '';
        [5, 4, 3, 2, 1].forEach((star) => {
          const count = all.filter((review) => review.r === star).length;
          const percent = total ? Math.round((count / total) * 100) : 0;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `rv__bar${this.state.filter === star ? ' is-active' : ''}`;
          button.setAttribute('aria-pressed', this.state.filter === star);
          button.innerHTML = `<span>${star} ★</span><span class="rv__bar-track"><span class="rv__bar-fill" style="width:${percent}%"></span></span><span>${count}</span>`;
          button.addEventListener('click', () => {
            this.state.filter = this.state.filter === star ? null : star;
            this.state.shown = this.perPage;
            this.render();
          });
          bars.appendChild(button);
        });
      }

      filtered() {
        let reviews = this.all;
        if (this.state.filter) reviews = reviews.filter((review) => review.r === this.state.filter);
        const byDate = (a, b) => (a.d < b.d ? 1 : -1);
        // "Destacadas": las nuevas primero y el resto en el orden del archivo, con fechas alternadas
        if (this.state.sort === 'featured') return [...reviews].sort((a, b) => (b.mine ? 1 : 0) - (a.mine ? 1 : 0));
        if (this.state.sort === 'high') return [...reviews].sort((a, b) => b.r - a.r || byDate(a, b));
        if (this.state.sort === 'low') return [...reviews].sort((a, b) => a.r - b.r || byDate(a, b));
        return [...reviews].sort((a, b) => (b.mine ? 1 : 0) - (a.mine ? 1 : 0) || byDate(a, b));
      }

      renderList() {
        const reviews = this.filtered();
        const label = this.querySelector('[data-filter-label]');
        label.textContent = `${reviews.length.toLocaleString('es-ES')} reseñas${this.state.filter ? ` de ${this.state.filter} ★` : ''}`;
        if (this.state.filter) {
          const clear = document.createElement('button');
          clear.type = 'button';
          clear.className = 'rv__clear';
          clear.textContent = 'Quitar filtro';
          clear.addEventListener('click', () => {
            this.state.filter = null;
            this.render();
          });
          label.appendChild(clear);
        }

        this.list.innerHTML = '';
        reviews.slice(0, this.state.shown).forEach((review) => this.list.appendChild(this.card(review)));
        this.moreWrap.hidden = reviews.length <= this.state.shown;
      }

      card(review) {
        const card = document.createElement('article');
        card.className = 'rv__card';

        const head = document.createElement('div');
        head.className = 'rv__card-head';
        head.innerHTML = `<span class="rv__stars" aria-label="${review.r} de 5 estrellas">${this.stars(review.r)}</span>`;
        if (review.mine) head.insertAdjacentHTML('beforeend', '<span class="rv__badge">Tu reseña</span>');
        card.appendChild(head);

        if (review.t) {
          const title = document.createElement('h3');
          title.className = 'rv__card-title';
          title.textContent = review.t;
          card.appendChild(title);
        }

        const body = document.createElement('p');
        body.className = 'rv__card-body';
        body.textContent = review.b;
        card.appendChild(body);

        if (review.p && review.p.length) {
          const photos = document.createElement('div');
          photos.className = 'rv__photos';
          review.p.forEach((src) => {
            const img = document.createElement('img');
            img.src = src;
            img.alt = `Foto de ${review.n}`;
            img.loading = 'lazy';
            photos.appendChild(img);
          });
          card.appendChild(photos);
        }

        const foot = document.createElement('div');
        foot.className = 'rv__card-foot';
        const author = document.createElement('span');
        author.className = 'rv__author';
        author.textContent = review.n;
        const date = document.createElement('span');
        date.textContent = new Date(`${review.d}T12:00:00`).toLocaleDateString('es-ES', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
        foot.append(author, date);
        card.appendChild(foot);

        return card;
      }

      toggleForm(open) {
        this.form.hidden = !open;
        if (open) {
          this.querySelector('[data-thanks]').hidden = true;
          this.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.form.querySelector('input[name="rating"]').focus({ preventScroll: true });
        }
      }

      async submit() {
        const data = new FormData(this.form);
        const error = this.querySelector('[data-form-error]');
        const submitButton = this.form.querySelector('[type="submit"]');
        const rating = Number(data.get('rating'));
        const name = String(data.get('name') || '').trim();
        const email = String(data.get('email') || '').trim();
        const body = String(data.get('body') || '').trim();

        if (!rating) return (error.textContent = 'Elige de 1 a 5 estrellas.');
        if (!name) return (error.textContent = 'Escribe tu nombre.');
        if (this.commentsUrl && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return (error.textContent = 'Escribe un email válido.');
        if (body.length < 5) return (error.textContent = 'Cuéntanos un poco más en tu opinión.');
        error.textContent = '';

        const review = {
          n: name,
          r: rating,
          d: new Date().toISOString().slice(0, 10),
          t: String(data.get('title') || '').trim(),
          b: body,
          mine: true,
        };

        if (this.commentsUrl) {
          submitButton.disabled = true;
          try {
            await this.postComment(review, email);
          } catch (postError) {
            error.textContent = 'No se pudo publicar la reseña. Inténtalo de nuevo en unos segundos.';
            submitButton.disabled = false;
            return;
          }
          submitButton.disabled = false;
        }

        this.local.unshift(review);
        this.saveLocal();

        this.form.reset();
        this.querySelector('[data-rating-text]').textContent = '';
        this.form.hidden = true;
        this.state = { filter: null, sort: 'featured', shown: this.perPage };
        this.querySelector('[data-sort]').value = 'featured';
        this.render();

        const thanks = this.querySelector('[data-thanks]');
        thanks.hidden = false;
        thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  );
}
